import {athubAxios} from '../../util'
import {EQUIPMENT_IN_OUT_SERVER, RELIABLE_SERVER, TICKET_SERVER, WORK_ORDER_SERVER} from "@/api";

const ReliableApi = {

    /**
     * 实时安全指数页面-统计根据部门统计事件/问题
     * @param params
     * @returns {Promise}
     */
    queryTicketChartInfo(params) {
        let url = `${TICKET_SERVER}/reliableindex/charts`;
        return new Promise((resolve, reject) => {
            athubAxios.post(url, params).then(responseBody => {
                if (responseBody.data.code == 200) {
                    resolve(responseBody.data.data);
                }
            }).catch(error => {
                reject('获取实时安全指数事件/问题信息失败');
            });
        });
    },

    /**
     * 实时安全指数页面-根据部门统计工单/变更
     * @param params
     * @returns {Promise}
     */
    queryWorkorderChartInfo(deptids, woclass) {
        let url = `${WORK_ORDER_SERVER}/eamWorkorder/workorder/safetyIndex/statistics?deptIds=${deptids}&woclass=${woclass}`;
        return new Promise((resolve, reject) => {
            athubAxios.get(url).then(responseBody => {
                if (responseBody.data.code == 200) {
                    resolve(responseBody.data.result);
                }
            }).catch(error => {
                reject("获取实时安全指数工单信息失败");
            });
        });
    },

    /**
     * 实时安全指数页面-缺编统计
     * @param params
     * @returns {Promise}
     */
    queryAuthorizedsChartInfo(params) {
        let url = `${RELIABLE_SERVER}/authorizeds/`;
        return new Promise((resolve, reject) => {
            athubAxios.post(url, params).then(responseBody => {
                if (responseBody.data.code == 200) {
                    resolve(responseBody.data.data);
                }
            }).catch(error => {
                reject("获取实时安全指数编制信息失败");
            });
        });
    },

    /**
     * 实时安全指数页面-统计根据部门统计人员进出安全指数
     * @param params
     * @returns {Promise}
     */
    queryRegisterChartInfo(params) {
        let url = `${EQUIPMENT_IN_OUT_SERVER}/registerrecord/reliableindexCharts/real`;
        return new Promise((resolve, reject) => {
            athubAxios.post(url, params).then(responseBody => {
                if (responseBody.data.code == 200) {
                    resolve(responseBody.data.result);
                }
            }).catch(error => {
                reject("获取实时安全指数人员进出信息失败");
            });
        });
    },

    /**
     * 实时安全指数页面-获取全量安全系数配置
     * @returns {Promise}
     */
    getDangerratioconf() {
        let url = `${RELIABLE_SERVER}/dangerrationconf/all`;
        return new Promise((resolve, reject) => {
            athubAxios.post(url, {}).then(responseBody => {
                if (responseBody.data.code == 200) {
                    resolve(responseBody.data.data);
                }
            }).catch(error => {
                reject("获取实时安全指数人员进出信息失败");
            });
        });
    },

    /**
     * 历史安全指数,安全指数分布,历史安全指数平均值
     * @param params
     * @returns {Promise<unknown>}
     */
    queryHisReliableValue(params) {
        let url = `${RELIABLE_SERVER}/hisreliable/reliableValue`;
        return new Promise((resolve, reject) => {
            athubAxios.post(url, params).then(responseBody => {
                if (responseBody.data.code == 200) {
                    resolve(responseBody.data.data);
                }
            }).catch(error => {
                reject("获取历史安全指数信息失败");
            });
        });
    },

};

export default ReliableApi;
